import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import { DepartmentProcess } from "commons/enum/deparment-process";
import { WorkOrdersPermission } from "commons/enum/permission";
import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { EditIconButton } from "share-components/mui-wrap/button/action-button";
type DepartmentProcessItemProps = {
  woItemId: string;
  type: DepartmentProcess;
  title: string;
  date?: string;
  amount?: number;
};
export const DepartmentProcessItem = observer(
  ({ woItemId, type, title, date, amount }: DepartmentProcessItemProps) => {
    const {
      workOrderManagement: {
        updateDepartmentProcess: { setProp },
      },
    } = useStores();
    const theme = useTheme();
    const onUpdateHandler = useCallback(() => {
      setProp("date", date);
      setProp("amount", amount);
      setProp("type", type);
      setProp("woItemId", woItemId);
      setProp("open", true);
    }, [amount, date, setProp, type, woItemId]);

    const permissionKey = useMemo(() => {
      switch (type) {
        case DepartmentProcess.Cut:
          return WorkOrdersPermission.Cut;
        case DepartmentProcess.Foil:
          return WorkOrdersPermission.Foil;
        case DepartmentProcess.OtherHandle:
          return WorkOrdersPermission.OtherHandle;
        case DepartmentProcess.Package:
          return WorkOrdersPermission.Package;
        case DepartmentProcess.Paste:
          return WorkOrdersPermission.Paste;
        case DepartmentProcess.Print:
          return WorkOrdersPermission.Print;
        case DepartmentProcess.Shape:
          return WorkOrdersPermission.Shape;
        default:
          return "";
      }
    }, [type]);
    return (
      <Table
        sx={{
          border: `0.5px solid ${theme.palette.divider}`,
          borderCollapse: "collapse",
          borderRadius: "4px",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>
              <Stack direction={"row"}>
                <Box
                  flex={1}
                  sx={{ textAlign: "center", textTransform: "capitalize" }}
                >
                  {title}
                </Box>
                <Box>
                  <EditIconButton
                    accessPermission={[permissionKey]}
                    tooltipTitle="Cập nhật"
                    onClick={onUpdateHandler}
                  ></EditIconButton>
                </Box>
              </Stack>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Ngày SX</TableCell>
            <TableCell align="center">Số lượng</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ height: "80px" }}>
          <TableRow>
            <TableCell align="center">{dateTimeDisplay(date) || ""}</TableCell>
            <TableCell align="center">
              {numberFormatAsString(amount?.toString() || "")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
);
